import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

import useSnackbar from "../../../hooks/useSnackbar";
import { getRelationshipContactDetails, getTransactionEft } from "../../../api/transaction-type";
import {
  salesOrderBillEftPaymentInfoTable,
  salesOrderBatchTransactionInfoTable,
  invoiceRelationshipContactTable,
} from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  TextField,
  Stack,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";

export default function InvoiceRelationship({ tabIndexP }) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [tabIndexRelationship, setTabIndexRelationship] = useState(0);
  const [rowData, setRowData] = useState([]);

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  //   useEffect(() => {
  //     if (user.token && tabIndexP === 3) {
  //       getTransactionEftData();
  //     }
  //   }, [tabIndexP]);

    async function getTransactionRelationShipData() {
      // setLoading(true);
      try {
        const { data } = await getRelationshipContactDetails(user.token, {
          id: params.docNo,
        });
        // setLoading(false);
        return { rows: data.data.data, total: data.data.total, error: false };
      } catch (error) {
        console.log(error);
        return { error: true };
      } finally {
        // setLoading(false);
      }
    }
  return (
    <>
      <Box className="viewDetilsBox">
        <Tabs
          value={tabIndexRelationship}
          onChange={(e, nv) => {
            setTabIndexRelationship(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tabs-sub-bkg"
        >
          <Tab label="Contacts" />
        </Tabs>
        <TabPanel value={tabIndexRelationship} index={0}>
        <Box className="viewDetilsBox">
            <Grid container spacing={1} mt={1}>
              <Grid item xs={12} sm={3} className="m-b-10">
                <TextField
                  id="outlined-basic"
                  label="Contact"
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={3} className="m-b-10">
                <FormControl size="small" fullWidth>
                  <InputLabel id="demo-select-small-label">ROLE</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value=""
                    label="Role"
                    //onChange={handleChange}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3} className="m-b-10">
                <FormControl size="small" fullWidth>
                  <InputLabel id="demo-select-small-label">VIEW</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value=""
                    label="View"
                    //onChange={handleChange}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            </Box>
            <Box
              sx={{
                backgroundColor: "#bbd9e8",
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button">New Contact</Button>
                <Button className="blue-button">Attach</Button>
                <Button className="blue-button">Update Primary</Button>
                <Button className="blue-button">Customize View</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              getTableRows={getTransactionRelationShipData}
              columns={invoiceRelationshipContactTable}
              refreshCounter={0}
            />
        </TabPanel>
      </Box>
    </>
  );
}
